import { useAppConfig } from '@app-studio-web/ui/contexts/AppConfigContext'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import DuoProgressHeader from './DuoProgressHeader'

/**
 * The v2 funnel shell: a light canvas, the Duolingo top chrome (back arrow plus
 * progress bar) and a generous content column. The mascot beats run without the
 * chrome, the way Duolingo's do. `withLogin` adds the same sign-in affordance
 * the baseline first screen has.
 */
export default function DuoFunnelLayout({
  children,
  footer,
  step,
  totalSteps,
  withLogin = false,
  withProgress = true,
}: {
  children: ReactNode
  /** Pinned to the bottom of the viewport, for persistent CTAs. */
  footer?: ReactNode
  step: number
  totalSteps: number
  withLogin?: boolean
  withProgress?: boolean
}) {
  const { logo } = useAppConfig()
  const { t } = useTranslation()

  return (
    <div className="min-h-dvh bg-white">
      <main className="duo-container flex min-h-dvh flex-col gap-6 pt-6 pb-8">
        {withLogin && !('ReactNativeWebView' in window) && (
          <header className="flex shrink-0 items-center justify-between">
            {logo}

            <Link
              className="text-duo-primary text-sm font-extrabold uppercase"
              data-testid="button-login"
              to="/account/sign-in"
            >
              {t('shared.signIn')}
            </Link>
          </header>
        )}

        {withProgress && (
          <DuoProgressHeader step={step} totalSteps={totalSteps} />
        )}

        <div className="flex grow flex-col">{children}</div>

        {footer && (
          <div className="border-duo-line sticky bottom-0 shrink-0 border-t bg-white pt-4 pb-2">
            {footer}
          </div>
        )}
      </main>
    </div>
  )
}
